/* Cookie Consent Banner - Web Component */
if (!customElements.get('cookie-consent-banner')) {
  class CookieConsentBanner extends HTMLElement {
    constructor() {
      super();
      this.STORAGE_KEY = 'cookie-consent-status';
    }

    connectedCallback() {
      const status = this.getConsentStatus();
      if (status === null) {
        this.removeAttribute('hidden');
      }

      const acceptBtn = this.querySelector('[data-cookie-accept]');
      const declineBtn = this.querySelector('[data-cookie-decline]');

      if (acceptBtn) {
        acceptBtn.addEventListener('click', this.handleAccept.bind(this));
      }
      if (declineBtn) {
        declineBtn.addEventListener('click', this.handleDecline.bind(this));
      }
    }

    getConsentStatus() {
      try {
        return localStorage.getItem(this.STORAGE_KEY);
      } catch (e) {
        return null;
      }
    }

    setConsentStatus(value) {
      try {
        localStorage.setItem(this.STORAGE_KEY, value);
      } catch (e) {
        /* localStorage unavailable */
      }
    }

    handleAccept() {
      this.setConsentStatus('accepted');
      this.dismiss();
      /* Signal Shopify Customer Privacy API if available */
      if (window.Shopify && window.Shopify.customerPrivacy) {
        window.Shopify.customerPrivacy.setTrackingConsent(true, function () {});
      }
    }

    handleDecline() {
      this.setConsentStatus('declined');
      this.dismiss();
      if (window.Shopify && window.Shopify.customerPrivacy) {
        window.Shopify.customerPrivacy.setTrackingConsent(false, function () {});
      }
    }

    dismiss() {
      this.setAttribute('hidden', '');
    }
  }

  customElements.define('cookie-consent-banner', CookieConsentBanner);
}
